// extracted by mini-css-extract-plugin
export default {"qr_svg_wrapper":"CustomFieldQr_qr_svg_wrapper__yD1q+","qr_svg":"CustomFieldQr_qr_svg__l3fjj"};